module.exports = __webpack_public_path__ + "favicon.ico?9fa7defa426dd2814bd064115d06c517";


//////////////////
// WEBPACK FOOTER
// ./favicon.ico
// module id = 463
// module chunks = 0